import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API, graphqlOperation } from "aws-amplify";
import { getPaymentSettings } from "../../graphql/queries";
import { PURGE } from "redux-persist";

export const fetchPaymentSettings = createAsyncThunk(
    'paymentSettings/fetchSettings',
    async () => {
        const response = await API.graphql(graphqlOperation(getPaymentSettings));
        return response.data.getPaymentSettings; // Assuming response.data contains the data in the required format
    }
);

const INITIAL_STATE = {
    Loaded: false,
    Enable_ItemWiseEntry: 0,
    Enable_CreditPeriod: 0,
    Enable_CreditLimit: 0,
    Enable_AutoPayReminder: 0,
    Enable_AutoReminderDays: 0,
}

const paymentSettingsSlice = createSlice({
    name: 'paymentSettings',
    initialState: INITIAL_STATE,
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(fetchPaymentSettings.pending, (state) => {
            state.Loaded = false;
        }).addCase(fetchPaymentSettings.fulfilled, (state, action) => {
            return {
                ...action.payload,
                Loaded: true,
            };
        }).addCase(fetchPaymentSettings.rejected, (state) => {
            state.Loaded = false;
        }).addCase(PURGE, () => INITIAL_STATE); // THIS LINE
    }
})
export const { } = paymentSettingsSlice.actions;
export default paymentSettingsSlice.reducer;